module.exports = __webpack_public_path__ + "static/media/version-history-icon.f3f0948b.svg";